import React from 'react'
import { ButtonProps } from '../../shared/types/PropTypes'
import { Loader2 } from 'lucide-react'

const Button = ({ className, title, loading, loadingText, startIcon, endIcon, titleClass, disabled = false, ...props }: ButtonProps) => {
    return (
        <button disabled={disabled} className={`flex items-center justify-center gap-2 transition-all duration-200 cursor-pointer ${className}`} {...props}>
            {loading ? (
                <>
                    <Loader2 className='h-4 w-4 animate-spin' />
                    <span>{loadingText}</span>
                </>
            ) : (
                <>
                    {startIcon && (
                        <span className='flex items-center'>{startIcon}</span>
                    )}

                    <span className={titleClass}>{title}</span>

                    {endIcon && (
                        <span className='flex items-center'>{endIcon}</span>
                    )}
                </>
            )}
        </button>
    )
}

export default Button